var _style, _circle, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0052B4;}\n\t.st1{fill:#F0F0F0;}\n\t.st2{fill:#FFDA44;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.4,155.8l5.5,17h17.9l-14.5,10.5l5.5,17l-14.5-10.5L98,200.3l5.5-17L89,172.8h17.9L112.4,155.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168.1,139.1l5.5,17h17.9L177,166.6l5.5,17l-14.5-10.5l-14.5,10.5l5.5-17l-14.5-10.5h17.9L168.1,139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M223.8,122.4l5.5,17h17.9L232.7,150l5.5,17l-14.5-10.5L209.3,167l5.5-17l-14.5-10.5h17.9L223.8,122.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.6,155.8l-5.5,17h-17.9l14.5,10.5l-5.5,17l14.5-10.5l14.5,10.5l-5.5-17l14.5-10.5h-17.9L399.6,155.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M343.9,139.1l-5.5,17h-17.9l14.5,10.5l-5.5,17l14.5-10.5l14.5,10.5l-5.5-17l14.5-10.5h-17.9L343.9,139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M288.2,122.4l-5.5,17h-17.9l14.5,10.5l-5.5,17l14.5-10.5l14.5,10.5l-5.5-17l14.5-10.5h-17.9L288.2,122.4z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M300.5,267.1L256,211.5l-22.3,11.1v22.3l-33.4,22.3h-22.3v28.8c32.6,13.2,55.7,45.2,55.7,82.5H256v-22.3 l22.3-22.3l22.3,22.3l22.3-22.3v-22.3l22.3-33.4L300.5,267.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXk);
export default __webpack_public_path__ + "static/media/xk.11fa9a85897de25abf48dfbee0ead3f1.svg";
export { ForwardRef as ReactComponent };